// src/components/GenrePage.js
import React, { useState, useEffect } from 'react';
import BookList from './BookFinder/BookList';
import './GenrePage.css'; // We will create this next

// We need our helper function here too
const normalizeBookData = (book) => {
    return {
      key: book.key,
      title: book.title,
      authors: book.authors ? book.authors.map(a => a.name) : ['Unknown Author'],
      cover_id: book.cover_id,
      publish_year: book.first_published,
    };
};

const GenrePage = ({ genre, onBack, onBookSelect }) => {
  const [books, setBooks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Capitalize the genre name for the title
  const genreTitle = genre.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

  useEffect(() => {
    const fetchBooks = async () => {
      if (!genre) return;
      setIsLoading(true);
      setBooks([]);
      setMessage('');
      try {
        const response = await fetch(`https://openlibrary.org/subjects/${genre}.json?limit=50`);
        const data = await response.json();
        if (data.works.length === 0) {
          setMessage(`No books found for ${genreTitle}.`);
        }
        const normalizedBooks = data.works.map(normalizeBookData);
        setBooks(normalizedBooks);
      } catch (error) {
        setMessage('Sorry, something went wrong fetching the books.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchBooks();
  }, [genre, genreTitle]); // Re-run this effect if the genre changes

  return (
    <div className="genre-page-container">
      <header className="genre-page-header">
        <button className="back-button" onClick={onBack}>&larr; Back to Home</button>
        <h1>{genreTitle}</h1>
        <p>Popular books in this genre</p>
      </header>
      <main className="results-container">
        {isLoading && <p className="info-message">Flipping through pages...</p>}
        {message && !isLoading && <p className="info-message">{message}</p>}
        {!isLoading && <BookList books={books} onBookSelect={onBookSelect} />}
      </main>
    </div>
  );
};

export default GenrePage;